import savingActionTypes from '../../constants/saving-action-types';

const setAsset = (source, { content = null, newSource = null, assetType = null }) => {
  const savingAction = {
    type: savingActionTypes.SET_ASSET,
    source,
  };

  if (newSource) {
    savingAction.newSource = newSource;
  }
  if (content) {
    savingAction.content = content;
  }
  if (assetType) {
    savingAction.assetType = assetType;
  }

  return savingAction;
};

export default setAsset;
